"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResellerHeaderInfo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const react_1 = require("react");
const _customer_area_1 = require("../../../../@customer-area");
const CustomerFavorites_1 = require("../../../../components/CustomerFavorites");
const useMenuClickHandlers_1 = require("../../../../components/MenuDrawer/useMenuClickHandlers");
const _cart_1 = require("../../../../@cart");
const useFavorites_1 = require("../../../../hooks/useFavorites");
const types_1 = require("../../../../types");
const ResellerInfo_1 = __importDefault(require("../../atoms/ResellerInfo"));
const ShoppingBagHeaderItem_1 = __importDefault(require("../../molecules/ShoppingBagHeaderItem"));
const ShoppingBagPopover_1 = require("../ShoppingBagPopover");
const ResellerHeaderInfo_styled_1 = require("./ResellerHeaderInfo.styled");
const MenuBannerKitNatal_1 = require("./MenuBannerKitNatal");
const _campaign_1 = require("../../../../@campaign");
const ResellerHeaderInfo = ({ brand, catalogName, catalogSlug, image, selectedItem, cartItems, totalCartItems, size = 'mobile', isVdf, shoppingCartVariant = 'icon', onClickCart, onClickResellerInfo, onCloseMenu, onOpenMenu, onClickCartItem, onClickCartFinishOrder, onOpenCart, onCloseCart, }) => {
    const [selectedTab, setSelectedTab] = (0, react_1.useState)(types_1.HeaderTab.RESELLER);
    const { isFavoritesEnabled } = (0, useFavorites_1.useFavorites)();
    const { isLoading } = (0, _cart_1.useCart)();
    const handleToggleMenu = () => {
        if (selectedTab === types_1.HeaderTab.MENU) {
            onCloseMenu === null || onCloseMenu === void 0 ? void 0 : onCloseMenu();
            setSelectedTab(types_1.HeaderTab.RESELLER);
        }
        else {
            onOpenMenu === null || onOpenMenu === void 0 ? void 0 : onOpenMenu();
            setSelectedTab(types_1.HeaderTab.MENU);
        }
    };
    const handleToggleSideCart = () => {
        if (selectedTab === types_1.HeaderTab.CHECKOUT) {
            onCloseCart === null || onCloseCart === void 0 ? void 0 : onCloseCart();
            setSelectedTab(types_1.HeaderTab.RESELLER);
        }
        else {
            onOpenCart === null || onOpenCart === void 0 ? void 0 : onOpenCart();
            setSelectedTab(types_1.HeaderTab.CHECKOUT);
        }
    };
    const handleCloseMenu = () => {
        onCloseMenu === null || onCloseMenu === void 0 ? void 0 : onCloseMenu();
    };
    const handleClickCart = () => {
        if (shoppingCartVariant === 'drawer') {
            handleToggleSideCart();
        }
        else {
            onClickCart === null || onClickCart === void 0 ? void 0 : onClickCart();
            setSelectedTab(types_1.HeaderTab.CHECKOUT);
        }
        handleCloseMenu();
    };
    const handleClickReseller = () => {
        onClickResellerInfo === null || onClickResellerInfo === void 0 ? void 0 : onClickResellerInfo();
        setSelectedTab(types_1.HeaderTab.RESELLER);
        handleCloseMenu();
    };
    const handleClickFavorites = () => {
        (0, useMenuClickHandlers_1.goTo)(`/${catalogSlug}${_customer_area_1.CUSTOMER_AREA_FAVORITES_PATH}`);
        handleCloseMenu();
    };
    (0, react_1.useEffect)(() => {
        setSelectedTab(selectedItem || types_1.HeaderTab.RESELLER);
    }, [selectedItem]);
    return ((0, jsx_runtime_1.jsxs)(ResellerHeaderInfo_styled_1.Wrapper, { children: [(0, jsx_runtime_1.jsx)(MenuBannerKitNatal_1.MenuBannerKitNatal, { catalogSlug: catalogSlug, isVdf: isVdf }), (0, jsx_runtime_1.jsx)(_campaign_1.TopCampaignBanner, { catalogSlug: catalogSlug, show: true, floraSection: "header-banner", css: { width: '100vw' } }), (0, jsx_runtime_1.jsxs)(flora_react_1.Box, Object.assign({ css: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 3fr 1fr',
                    paddingTop: '$2',
                } }, { children: [(0, jsx_runtime_1.jsx)(ResellerHeaderInfo_styled_1.EdgeButtonWrapper, { children: (0, jsx_runtime_1.jsx)(ResellerHeaderInfo_styled_1.ItemHighlight, Object.assign({ selected: selectedTab === types_1.HeaderTab.MENU, align: "right", anchor: "left" }, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Button, Object.assign({ variant: "unstyled", "data-flora": "button", "data-flora-text": "menu", "autotagging-flora": "on", "data-autotagging-flora-section": "menu", "aria-label": "Clique para acessar menu", onClick: handleToggleMenu }, { children: (0, jsx_runtime_1.jsx)(flora_react_icons_1.ThreeLinesHorizontal1Icon, { color: "$nonInteractivePredominant" }) })) })) }), (0, jsx_runtime_1.jsx)(flora_react_1.Flex, Object.assign({ justify: "center" }, { children: (0, jsx_runtime_1.jsx)(ResellerHeaderInfo_styled_1.ResellerInfoWrapper, Object.assign({ size: size }, { children: (0, jsx_runtime_1.jsx)(ResellerHeaderInfo_styled_1.ItemHighlight, Object.assign({ align: "center", selected: selectedTab === types_1.HeaderTab.RESELLER, anchor: "center" }, { children: (0, jsx_runtime_1.jsx)(ResellerInfo_1.default, { brand: brand, image: image, catalogName: catalogName, size: size, onClickResellerInfo: handleClickReseller }) })) })) })), (0, jsx_runtime_1.jsxs)(flora_react_1.Flex, Object.assign({ align: "center", css: {
                            '@mobile': {
                                gap: '$4',
                            },
                            '@desktop': {
                                gap: '$10',
                            },
                        } }, { children: [isFavoritesEnabled && (0, jsx_runtime_1.jsx)(CustomerFavorites_1.GoToFavorites, { onClick: handleClickFavorites }), (0, jsx_runtime_1.jsx)(flora_react_1.Box, Object.assign({ css: { width: '100%', minWidth: '60px' } }, { children: (0, jsx_runtime_1.jsx)(ResellerHeaderInfo_styled_1.EdgeButtonWrapper, { children: (0, jsx_runtime_1.jsxs)(ResellerHeaderInfo_styled_1.ItemHighlight, Object.assign({ selected: selectedTab === types_1.HeaderTab.CHECKOUT, align: "left", anchor: "right" }, { children: [shoppingCartVariant === 'icon' ? ((0, jsx_runtime_1.jsx)(ShoppingBagHeaderItem_1.default, { isLoading: isLoading, totalCartItems: totalCartItems, onClick: handleClickCart })) : null, ['popover', 'drawer'].includes(shoppingCartVariant) ? ((0, jsx_runtime_1.jsx)(ShoppingBagPopover_1.ShoppingBagPopover, { isLoading: isLoading, totalCartItems: totalCartItems, cartItems: cartItems !== null && cartItems !== void 0 ? cartItems : [], onClickItem: onClickCartItem, onClickFinishOrder: onClickCartFinishOrder, onClick: handleClickCart })) : null] })) }) }))] }))] }))] }));
};
exports.ResellerHeaderInfo = ResellerHeaderInfo;
